import { toast as sonnerToast } from 'sonner';
import { MessageOptions } from './message.types';
import { SVG } from '../svg';
import { InlineSpinner } from '../inline-spinner';
import { Text } from '../text';
import { Icons } from '../icons';
import { StyledMessage } from './message.styled';

export const message = (options: MessageOptions) => {
  const { type = 'info', text, ...restProps } = options;

  const icons = {
    info: <SVG src={Icons.InformationCircleFilled} />,
    success: <SVG src={Icons.CheckCircleFilled} />,
    warning: <SVG src={Icons.ExclamationCircleFilled} />,
    error: <SVG src={Icons.CrossCircleFilled} />,
  };

  return sonnerToast.custom(
    () => (
      <StyledMessage $type={type}>
        {type === 'pending' ? (
          <InlineSpinner color="primary.400" />
        ) : (
          icons[type]
        )}
        <Text>{text}</Text>
      </StyledMessage>
    ),
    {
      ...restProps,
      toasterId: restProps.toasterId ?? 'message-toaster',
    }
  );
};
